import { BlogPost } from '../types';
import personalizedGiftsForFourYearOlds from './personalizedGiftsForFourYearOlds';
import howToMakeAPersonalizedStorybook from './howToMakeAPersonalizedStorybook';
import giftsForNewSiblings from './giftsForNewSiblings';
import whyPersonalizedBooksHelpKidsRead from './whyPersonalizedBooksHelpKidsRead';
import nameDayGiftIdeas from './nameDayGiftIdeas';
import christmasGiftsKidsHaveEverything from './christmasGiftsKidsHaveEverything';

// German translations
import personalizedGiftsForFourYearOldsDe from './personalizedGiftsForFourYearOlds.de';
import howToMakeAPersonalizedStorybookDe from './howToMakeAPersonalizedStorybook.de';
import giftsForNewSiblingsDe from './giftsForNewSiblings.de';
import whyPersonalizedBooksHelpKidsReadDe from './whyPersonalizedBooksHelpKidsRead.de';
import nameDayGiftIdeasDe from './nameDayGiftIdeas.de';
import christmasGiftsKidsHaveEverythingDe from './christmasGiftsKidsHaveEverything.de';

// French translations
import personalizedGiftsForFourYearOldsFr from './personalizedGiftsForFourYearOlds.fr';
import howToMakeAPersonalizedStorybookFr from './howToMakeAPersonalizedStorybook.fr';
import giftsForNewSiblingsFr from './giftsForNewSiblings.fr';
import whyPersonalizedBooksHelpKidsReadFr from './whyPersonalizedBooksHelpKidsRead.fr';
import nameDayGiftIdeasFr from './nameDayGiftIdeas.fr';
import christmasGiftsKidsHaveEverythingFr from './christmasGiftsKidsHaveEverything.fr';

// Arabic translations
import personalizedGiftsForFourYearOldsAr from './personalizedGiftsForFourYearOlds.ar';
import howToMakeAPersonalizedStorybookAr from './howToMakeAPersonalizedStorybook.ar';
import giftsForNewSiblingsAr from './giftsForNewSiblings.ar';
import whyPersonalizedBooksHelpKidsReadAr from './whyPersonalizedBooksHelpKidsRead.ar';
import nameDayGiftIdeasAr from './nameDayGiftIdeas.ar';
import christmasGiftsKidsHaveEverythingAr from './christmasGiftsKidsHaveEverything.ar';

// Turkish translations
import personalizedGiftsForFourYearOldsTr from './personalizedGiftsForFourYearOlds.tr';
import howToMakeAPersonalizedStorybookTr from './howToMakeAPersonalizedStorybook.tr';
import giftsForNewSiblingsTr from './giftsForNewSiblings.tr';
import whyPersonalizedBooksHelpKidsReadTr from './whyPersonalizedBooksHelpKidsRead.tr';
import nameDayGiftIdeasTr from './nameDayGiftIdeas.tr';
import christmasGiftsKidsHaveEverythingTr from './christmasGiftsKidsHaveEverything.tr';

// Greek translations
import personalizedGiftsForFourYearOldsEl from './personalizedGiftsForFourYearOlds.el';
import howToMakeAPersonalizedStorybookEl from './howToMakeAPersonalizedStorybook.el';
import giftsForNewSiblingsEl from './giftsForNewSiblings.el';
import whyPersonalizedBooksHelpKidsReadEl from './whyPersonalizedBooksHelpKidsRead.el';
import nameDayGiftIdeasEl from './nameDayGiftIdeas.el';
import christmasGiftsKidsHaveEverythingEl from './christmasGiftsKidsHaveEverything.el';

/** All blog posts, newest first. Drives /blog, /blog/:slug and the sitemap. */
export const POSTS: BlogPost[] = [
	christmasGiftsKidsHaveEverything,
	nameDayGiftIdeas,
	whyPersonalizedBooksHelpKidsRead,
	giftsForNewSiblings,
	howToMakeAPersonalizedStorybook,
	personalizedGiftsForFourYearOlds,

	christmasGiftsKidsHaveEverythingDe,
	nameDayGiftIdeasDe,
	whyPersonalizedBooksHelpKidsReadDe,
	giftsForNewSiblingsDe,
	howToMakeAPersonalizedStorybookDe,
	personalizedGiftsForFourYearOldsDe,

	christmasGiftsKidsHaveEverythingFr,
	nameDayGiftIdeasFr,
	whyPersonalizedBooksHelpKidsReadFr,
	giftsForNewSiblingsFr,
	howToMakeAPersonalizedStorybookFr,
	personalizedGiftsForFourYearOldsFr,

	christmasGiftsKidsHaveEverythingAr,
	nameDayGiftIdeasAr,
	whyPersonalizedBooksHelpKidsReadAr,
	giftsForNewSiblingsAr,
	howToMakeAPersonalizedStorybookAr,
	personalizedGiftsForFourYearOldsAr,

	christmasGiftsKidsHaveEverythingTr,
	nameDayGiftIdeasTr,
	whyPersonalizedBooksHelpKidsReadTr,
	giftsForNewSiblingsTr,
	howToMakeAPersonalizedStorybookTr,
	personalizedGiftsForFourYearOldsTr,

	christmasGiftsKidsHaveEverythingEl,
	nameDayGiftIdeasEl,
	whyPersonalizedBooksHelpKidsReadEl,
	giftsForNewSiblingsEl,
	howToMakeAPersonalizedStorybookEl,
	personalizedGiftsForFourYearOldsEl,
].sort((a, b) => (a.date < b.date ? 1 : -1));

export const postBySlug = (slug?: string): BlogPost | undefined =>
	POSTS.find((p) => p.slug === slug);

export default POSTS;
